import { ThemeEvents } from '@theme/events';

const linkedProducts = [
  { triggerVariantId: 57314644853109, linkedVariantId: 40927316344877 },
];

const originalFetch = window.fetch.bind(window);

let isSyncing = false;
let syncTimeout = null;

const getCartDrawerSectionId = () => document.querySelector('cart-drawer')?.dataset.sectionId;

const getCartSections = () => {
  const sections = ['auto-gifts'];
  const cartDrawerSectionId = getCartDrawerSectionId();
  if (cartDrawerSectionId) sections.push(cartDrawerSectionId);
  return sections.join(',');
};

const getCart = async () => {
  const response = await originalFetch('/cart.js', { headers: { Accept: 'application/json' } });
  return response.ok ? response.json() : null;
};

const getVariantItems = (cart, variantId) =>
  cart.items.filter((item) => String(item.variant_id) === String(variantId));

const getVariantQuantity = (items) =>
  items.reduce((quantity, item) => quantity + item.quantity, 0);

const dispatchCartUpdated = (cartData) => {
  if (!cartData?.sections) return;
  document.dispatchEvent(
    new CustomEvent(ThemeEvents.cartUpdated, {
      bubbles: true,
      detail: {
        data: {
          itemCount: cartData.item_count,
          sections: cartData.sections,
          source: 'cart-linked-products',
        },
      },
    }),
  );
};

const addLinkedVariant = async (variantId, quantity) => {
  const response = await originalFetch(Theme.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity }],
      sections: getCartSections(),
      sections_url: window.location.pathname,
    }),
  });
  return response.ok ? response.json() : null;
};

const updateLinkedVariant = async (item, quantity) => {
  const response = await originalFetch(Theme.routes.cart_change_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      id: item.key,
      quantity,
      sections: getCartSections(),
      sections_url: window.location.pathname,
    }),
  });
  return response.ok ? response.json() : null;
};

const syncLinkedProducts = async () => {
  if (isSyncing) return;
  isSyncing = true;
  try {
    const cart = await getCart();
    if (!cart) return;
    let didSync = false;
    for (const linkedProduct of linkedProducts) {
      const triggerItems = getVariantItems(cart, linkedProduct.triggerVariantId);
      const linkedItems = getVariantItems(cart, linkedProduct.linkedVariantId);
      const triggerQuantity = getVariantQuantity(triggerItems);
      const linkedQuantity = getVariantQuantity(linkedItems);
      if (triggerQuantity === 0 || linkedQuantity >= triggerQuantity) continue;
      const quantityToAdd = triggerQuantity - linkedQuantity;
      const cartData =
        linkedItems.length > 0
          ? await updateLinkedVariant(linkedItems[0], linkedItems[0].quantity + quantityToAdd)
          : await addLinkedVariant(linkedProduct.linkedVariantId, quantityToAdd);
      didSync = true;
      dispatchCartUpdated(cartData);
    }
    if (didSync && Theme.template?.name === 'cart') {
      window.location.reload();
    }
  } catch (error) {
    console.error('Cart linked products sync failed:', error);
  } finally {
    isSyncing = false;
  }
};

const scheduleSyncLinkedProducts = () => {
  window.clearTimeout(syncTimeout);
  syncTimeout = window.setTimeout(syncLinkedProducts, 150);
};

const isCartMutation = (resource) => {
  const url = typeof resource === 'string' ? resource : resource?.url;
  if (!url) return false;
  return url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');
};

window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (!isSyncing && isCartMutation(args[0])) {
    scheduleSyncLinkedProducts();
  }
  return response;
};

document.addEventListener(ThemeEvents.cartUpdated, (event) => {
  if (event.detail?.data?.source !== 'cart-linked-products') {
    scheduleSyncLinkedProducts();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSyncLinkedProducts, { once: true });
} else {
  scheduleSyncLinkedProducts();
}